import $ from 'jquery';


const $products = $('.also-bought__bottom__product');
const $priceElement = $('.also-bought__top__cart__price');
let $addToCart = $('#also-bought_add_to_cart_button');
let active_products = [];

function calculatePrice() {
	let calculatedPrice = 0;

	active_products.map((product) => {
		const $product = $('.also-bought__bottom__product[data-id=' + product + ']');
		const $price = parseFloat($product.attr('data-price'));
		calculatedPrice += $price;
	});

	$priceElement.attr('data-price', calculatedPrice.toLocaleString( 'de-de' )+' €');
}

$products.each( function() {
	const $product = $(this);
	const $checkbox = $product.find('input[type=checkbox]');
	const $price = $product.data('price');
	const $id = $product.data('id');
	active_products.push($id);

	const $connected_element = $('.also-bought__top .also-bought__top__products__product[data-id=' + $id + ']');

	$checkbox.on('change', function () {
		$connected_element.toggleClass( 'unavailable' );

		if( $(this).prop('checked') ) {
			active_products.push($id);
		} else {
			active_products.splice( active_products.indexOf($id), 1 );
		}
		calculatePrice();
		$addToCart.attr('value', active_products);
	});

	$addToCart.attr('value', active_products);
} );
calculatePrice();



